<template>
  <form-section
    :direction="direction"
    :error="error"
    :hint="hint"
    :label="label"
    :label-visible="labelVisible"
    :full-width="fullWidth"
    :name="name"
  >
    <div class="tags-input">
      <multiselect
        :disabled="isDisabled"
        :hide-selected="true"
        :multiple="true"
        :options="options"
        :placeholder="placeholder"
        :taggable="taggable"
        :value="value"
        label="label"
        select-label=""
        track-by="value"
        @tag="handleTag"
        @input="handleInput"
      />
    </div>
  </form-section>
</template>

<script>
import InputCommon from './InputCommon'
import Multiselect from 'vue-multiselect'

export default {
  name: 'TagsInput',
  mixins: [InputCommon],
  components: {
    Multiselect
  },
  props: {
    // Format: [{label: 'Germany', value: 'De'}, ...]
    options: {
      type: Array,
      required: true
    },
    value: {
      type: Array,
      required: true,
    },
    taggable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleInput (tags) {
      this.$emit('input', tags)
    },
    handleTag (tag) {
      const tags = this.value.slice(0) || []
      tags.push({
        label: tag,
        value: tag
      })
      this.$emit('tag', tags)
    }
  }
}
</script>

<style lang="sass">
@import '~styles/imports'

fieldset[disabled] .multiselect
  pointer-events: none

.multiselect__spinner
  position: absolute
  right: 1px
  top: 1px
  width: 48px
  height: 35px
  background: #fff
  display: block

.multiselect__spinner:before,
.multiselect__spinner:after
  position: absolute
  content: ""
  top: 50%
  left: 50%
  margin: -8px 0 0 -8px
  width: 16px
  height: 16px
  border-radius: 100%
  border-color: var(--mainColor) transparent transparent
  border-style: solid
  border-width: 2px
  box-shadow: 0 0 0 1px transparent

.multiselect__spinner:before
  animation: spinning 2.4s cubic-bezier(0.41, 0.26, 0.2, 0.62)
  animation-iteration-count: infinite

.multiselect__spinner:after
  animation: spinning 2.4s cubic-bezier(0.51, 0.09, 0.21, 0.8)
  animation-iteration-count: infinite

.multiselect__loading-enter-active,
.multiselect__loading-leave-active
  transition: opacity 0.4s ease-in-out
  opacity: 1

.multiselect__loading-enter,
.multiselect__loading-leave-active
  opacity: 0

.multiselect,
.multiselect__input,
.multiselect__single
  font-family: inherit
  font-size: 14px
  touch-action: manipulation

.multiselect
  box-sizing: content-box
  display: block
  position: relative
  width: 100%
  min-height: 40px
  text-align: left
  color: $color-text-base

.multiselect *
  box-sizing: border-box

.multiselect:focus
  outline: none

.multiselect--disabled
  pointer-events: none
  opacity: 0.6

.multiselect--active
  z-index: 50

.multiselect--active:not(.multiselect--above) .multiselect__current,
.multiselect--active:not(.multiselect--above) .multiselect__input,
.multiselect--active:not(.multiselect--above) .multiselect__tags
  border-bottom-left-radius: 0
  border-bottom-right-radius: 0

.multiselect--above.multiselect--active .multiselect__current,
.multiselect--above.multiselect--active .multiselect__input,
.multiselect--above.multiselect--active .multiselect__tags
  border-top-left-radius: 0
  border-top-right-radius: 0

.multiselect__input,
.multiselect__single
  background: #fff
  border-radius: $border-radius
  border: none
  box-sizing: border-box
  display: inline-block
  line-height: 20px
  margin-bottom: 8px
  min-height: 20px
  padding: 11px 0 0 13px
  position: relative
  transition: border 0.1s ease
  vertical-align: top
  width: calc(100%)

  &::placeholder
    color: $color-text-base
    font-weight: 600

.multiselect__tag ~ .multiselect__input,
.multiselect__tag ~ .multiselect__single
  width: auto

.multiselect__input:hover,
.multiselect__single:hover
  border-color: #cfcfcf

.multiselect__input:focus,
.multiselect__single:focus
  border-color: #a8a8a8
  outline: none

.multiselect__single
  padding-left: 6px
  margin-bottom: 8px

.multiselect__tags-wrap
  display: inline

.multiselect__tags
  background: #fff
  border-radius: $border-radius
  border: 1px solid #E8E8E8
  display: block
  min-height: 59px
  padding: 6px 40px 0 6px

.multiselect__tag
  background: $color-grey-1
  border-radius: $border-radius
  color: $color-text-base
  display: inline-block
  font-size: 15px
  font-weight: 500
  line-height: 1
  margin-right: 4px
  max-width: 100%
  overflow: hidden
  padding: 15px 48px 14px 19px
  position: relative
  text-overflow: ellipsis
  white-space: nowrap

.multiselect__tag-icon
  border-radius: $border-radius
  bottom: 0
  cursor: pointer
  font-style: initial
  font-weight: 700
  line-height: 22px
  margin-left: 7px
  position: absolute
  right: 14px
  text-align: center
  top: 50%
  margin-top: -9px
  transition: all 0.2s ease
  width: 22px

.multiselect__tag-icon:after
  content: "×"
  color: rgba($color-grey-2, .35)
  font-size: 24px

.multiselect__current
  line-height: 16px
  min-height: 40px
  box-sizing: border-box
  display: block
  overflow: hidden
  padding: 8px 12px 0
  padding-right: 30px
  white-space: nowrap
  margin: 0
  text-decoration: none
  border-radius: $border-radius
  border: 1px solid #E8E8E8
  cursor: pointer

.multiselect__select
  line-height: 16px
  display: block
  position: absolute
  box-sizing: border-box
  width: 40px
  height: 59px
  right: 1px
  top: -2px
  padding: 4px 8px
  margin: 0
  text-decoration: none
  text-align: center
  cursor: pointer
  transition: transform 0.2s ease

.multiselect__select:before
  position: relative
  right: 0
  top: 65%
  color: #999
  margin-top: 4px
  border-style: solid
  border-width: 5px 5px 0 5px
  border-color: #999999 transparent transparent transparent
  content: ""

.multiselect__placeholder
  color: #ADADAD
  display: inline-block
  margin-bottom: 10px
  padding-top: 2px

.multiselect--active .multiselect__placeholder
  display: none

.multiselect__content-wrapper
  position: absolute
  display: block
  background: #fff
  width: 100%
  max-height: 240px
  overflow: auto
  border: 1px solid #E8E8E8
  border-top: none
  border-bottom-left-radius: 5px
  border-bottom-right-radius: 5px
  z-index: 50
  -webkit-overflow-scrolling: touch

.multiselect__content
  list-style: none
  display: inline-block
  padding: 0
  margin: 0
  min-width: 100%
  vertical-align: top

.multiselect--above .multiselect__content-wrapper
  bottom: 100%
  border-bottom-left-radius: 0
  border-bottom-right-radius: 0
  border-top-left-radius: 5px
  border-top-right-radius: 5px
  border-bottom: none
  border-top: 1px solid #E8E8E8

.multiselect__content::webkit-scrollbar
  display: none

.multiselect__element
  display: block

.multiselect__option
  display: block
  padding: 14px 21px
  min-height: 40px
  line-height: 16px
  text-decoration: none
  text-transform: none
  vertical-align: middle
  position: relative
  cursor: pointer
  white-space: nowrap
  font-weight: 600

.multiselect__option:after
  top: 0
  right: 0
  position: absolute
  line-height: 40px
  padding-right: 12px
  padding-left: 20px

.multiselect__option--highlight
  background: var(--mainColor)
  outline: none
  color: white

.multiselect__option--highlight:after
  content: attr(data-select)
  background: var(--mainColor)
  color: white

.multiselect__option--selected
  background: #F3F3F3
  color: #35495E
  font-weight: bold

.multiselect__option--selected:after
  content: attr(data-selected)
  color: silver

.multiselect__option--selected.multiselect__option--highlight
  background: #FF6A6A
  color: #fff

.multiselect__option--selected.multiselect__option--highlight:after
  background: #FF6A6A
  content: attr(data-deselect)
  color: #fff

.multiselect--disabled
  background: #ededed
  pointer-events: none

.multiselect__option--disabled
  background: #ededed
  color: #a6a6a6
  cursor: text
  pointer-events: none

.multiselect__option--disabled.multiselect__option--highlight
  background: #dedede !important

.multiselect-enter-active,
.multiselect-leave-active
  transition: all 0.15s ease

.multiselect-enter,
.multiselect-leave-active
  opacity: 0

.multiselect__strong
  margin-bottom: 8px
  line-height: 20px
  display: inline-block
  vertical-align: top

*[dir="rtl"] .multiselect
    text-align: right

*[dir="rtl"] .multiselect__select
    right: auto
    left: 1px

*[dir="rtl"] .multiselect__tags
    padding: 8px 8px 0px 40px

*[dir="rtl"] .multiselect__content
    text-align: right

*[dir="rtl"] .multiselect__option:after
    right: auto
    left: 0

*[dir="rtl"] .multiselect__clear
    right: auto
    left: 12px

*[dir="rtl"] .multiselect__spinner
    right: auto
    left: 1px

@keyframes spinning
  from transform:rotate(0)   to transform:rotate(2turn)

</style>



// WEBPACK FOOTER //
// src/components/forms/TagsInput.vue